import React from 'react';
import './Methode.css';

const Methode = () => {
  return (
    <section className="methode-section">
      <div className="methode-container">
        <div className="methode-header">
          <h1 className="methode-title">Notre Méthode</h1>
          <p className="methode-intro">
            Notre méthodologie repose sur un principe simple mais puissant : la prospection efficace n'est pas une question de volume mais d'intelligence stratégique et d'exécution impeccable.
          </p>
        </div>

        <div className="methode-steps">
          <div className="methode-step">
            <div className="step-number">1</div>
            <h2 className="step-title">Évaluation approfondie</h2>
            <p className="step-description">
              Avant toute action, nous réalisons un scoring complet de votre dispositif commercial existant : structuration de votre process, efficacité de vos messages, pertinence de vos canaux, capacité de traitement des leads et taux de conversion actuel.
            </p>
          </div>

          <div className="methode-step">
            <div className="step-number">2</div>
            <h2 className="step-title">Conception stratégique</h2>
            <p className="step-description">
              Sur base de cette évaluation, nous élaborons votre plan d'action personnalisé en sélectionnant les leviers à plus fort potentiel pour votre activité : LinkedIn pour le ciblage précis, email pour la séquence d'engagement, landing pages pour la conversion, ou webinaires pour la démonstration d'expertise.
            </p>
          </div>

          <div className="methode-step">
            <div className="step-number">3</div>
            <h2 className="step-title">Déploiement multi-canal</h2>
            <p className="step-description">
              Notre collectif d'experts se met en action pour créer et déployer vos campagnes synchronisées : copywriting percutant, design optimisé, ciblage affiné par l'IA et orchestration parfaite de tous les touchpoints avec vos prospects.
            </p>
          </div>

          <div className="methode-step">
            <div className="step-number">4</div>
            <h2 className="step-title">Suivi et optimisation</h2>
            <p className="step-description">
              Votre dashboard Prosperian vous donne accès en temps réel aux performances de chaque canal et de chaque campagne. Notre équipe ajuste en continu les paramètres pour maximiser votre ROI et accélérer votre pipeline commercial.
            </p>
          </div>

          <div className="methode-step">
            <div className="step-number">5</div>
            <h2 className="step-title">Qualification et transfert</h2>
            <p className="step-description">
              Nous qualifions chaque lead généré et organisons les rendez-vous directement dans l'agenda de vos commerciaux. Vous ne vous concentrez que sur ce qui compte : transformer ces opportunités en contrats signés.
            </p>
          </div>
        </div>

        <div className="methode-framework">
          <h2 className="framework-title">Le modèle PROSP© de mesure de l'efficacité</h2>
          <p className="framework-intro">
            Pour une évaluation complète de votre prospection, nous recommandons le framework PROSP©, une marque de fabrique de Prosperian :
          </p>

          <div className="framework-grid">
            <div className="framework-item">
              <h3 className="framework-item-title">P - Productivité</h3>
              <p className="framework-item-subtitle">Mesure de l'efficience des efforts de prospection</p>
              <ul className="framework-item-list">
                <li>Leads qualifiés par canal</li>
                <li>Taux de conversion par étape du funnel</li>
                <li>Vélocité du pipeline (vitesse de progression des opportunités)</li>
              </ul>
            </div>

            <div className="framework-item">
              <h3 className="framework-item-title">R - Rentabilité</h3>
              <p className="framework-item-subtitle">Évaluation de l'impact financier de la prospection</p>
              <ul className="framework-item-list">
                <li>Coût par lead qualifié</li>
                <li>Coût d'acquisition client (CAC)</li>
                <li>Retour sur investissement marketing (ROMI)</li>
                <li>Payback period (délai de récupération du CAC)</li>
              </ul>
            </div>

            <div className="framework-item">
              <h3 className="framework-item-title">O - Opportunités</h3>
              <p className="framework-item-subtitle">Analyse de la qualité des opportunités générées</p>
              <ul className="framework-item-list">
                <li>Valeur moyenne des deals</li>
                <li>Taux de conversion opportunité-client</li>
                <li>Durée du cycle de vente</li>
                <li>Predictive quality score (score prédictif de qualité)</li>
              </ul>
            </div>

            <div className="framework-item">
              <h3 className="framework-item-title">S - Satisfaction</h3>
              <p className="framework-item-subtitle">Mesure de l'expérience client durant la prospection</p>
              <ul className="framework-item-list">
                <li>Taux d'engagement multicanal</li>
                <li>Net Promoter Score précoce</li>
                <li>Feedback qualitatif sur le processus de vente</li>
                <li>Taux de désabonnement/opt-out</li>
              </ul>
            </div>

            <div className="framework-item">
              <h3 className="framework-item-title">P - Pérennité</h3>
              <p className="framework-item-subtitle">Évaluation de l'impact à long terme de la prospection</p>
              <ul className="framework-item-list">
                <li>Taux de rétention des clients acquis</li>
                <li>Valeur vie client (LTV)</li>
                <li>Taux d'expansion des comptes</li>
                <li>Taux de référencement (clients devenant ambassadeurs)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="methode-cta">
        <div className="methode-container">
          <h2 className="cta-title">TESTEZ VOTRE ÉLIGIBILITÉ AU PROGRAMME PROSPERIAN</h2>
          <p className="cta-description">
            89% des entreprises ne sont pas prêtes à maximiser leur ROI en prospection. Découvrez votre score en 2 minutes et accédez à notre programme sur sélection.
          </p>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">OBTENIR MON SCORE</button>
          </a>
        </div>
      </div>

      <div className="methode-cta secondary">
        <div className="methode-container">
          <h2 className="cta-title">Prêt à transformer votre approche commerciale ?</h2>
          <p className="cta-description">
            Rejoignez les entreprises qui ont déjà boosté leur ROI grâce à notre méthode éprouvée.
          </p>
          <div className="cta-buttons">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Demander une démo</button>
            </a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
              <button className="cta-button secondary">Tester mon éligibilité</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methode; 